<template>
    <el-card class="box-card">
        <el-tabs v-model="activeName" @tab-click="tabClickChange">
            <el-tab-pane name="first" label="待处理">
                    <div class="query-panel">
                        <el-form :inline="true">
                            <el-form-item>
                                <el-button size="small" type="primary" @click="showAllReports">查询</el-button>
                            </el-form-item>
                        </el-form>
                    </div>

                    <el-table :data="dataHandled" border height="600">
                        <el-table-column prop="accountSid" label="被举报人sid"></el-table-column>
                        <el-table-column prop="userId" label="被举报角色长id"></el-table-column>
                        <el-table-column prop="nick" label="被举报人昵称"></el-table-column>
                        <el-table-column prop="level" label="被举报人等级"></el-table-column>
                        <el-table-column prop="charge" label="被举报人总充值（分）"></el-table-column>
                        <el-table-column prop="reportType" label="举报类型">
                            <template slot-scope="scope">
                                <span v-for="item in reportType" v-if="scope.row.reportType == item.value">{{item.label}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="speakTime" label="发送时间"></el-table-column>
                        <el-table-column prop="reportId" label="举报人id"></el-table-column>
                        <el-table-column prop="reportNick" label="举报人昵称"></el-table-column>
                        <el-table-column prop="reportContent" label="举报内容"></el-table-column>
                        <el-table-column prop="speakTime" label="发言时间"></el-table-column>
                        <el-table-column prop="reportTime" label="举报时间"></el-table-column>
                        <el-table-column prop="" label="处理情况"></el-table-column>
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <template v-if="scope.row.reportType == 201">
                                    <el-button class="player-btn" type="success" @click="showClearTribeName(scope.row)">清除部落昵称</el-button>
                                </template>
                                <template v-else-if="scope.row.reportType == 202">
                                    <el-button class="player-btn" type="success" @click="showClearTribeBulletin(scope.row)">清除部落公告</el-button>
                                </template>
                                <template v-else>
                                    <el-button class="player-btn" type="primary" @click="blockAndForbidShow('block',scope.row)">封停角色</el-button>
                                    <el-button class="player-btn" type="primary" @click="blockAndForbidShow('forbid',scope.row)">角色禁言</el-button>
                                    <el-button class="player-btn" type="primary" @click="blockAndForbidShow('fakeForbid',scope.row)">角色伪禁言
                                        <el-tooltip class="item" effect="dark" placement="top-start">
                                            <div slot="content">
                                                （玩家发言内容仅自己可见，不会推送给别人）
                                            </div>
                                            <i class="el-icon-info"></i>
                                        </el-tooltip>
                                    </el-button>
                                    <el-button class="player-btn" type="primary" @click="renameShow(scope.row)">修改角色名（无卡）</el-button>
                                </template>
                                <el-button class="player-btn" type="primary" @click="handleReports(scope.row)">不处理</el-button>
                                <template v-if="scope.row.reportType == 7 || scope.row.reportType == 2">
                                    <el-button class="player-btn" type="primary" @click="toChat(scope.row.userId)">查询聊天记录</el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
                                       layout="total, prev, pager, next, jumper" :total="totalRow">
                        </el-pagination>
                    </div>

                    <el-dialog :title="blockAndForbidType =='block'?'封号':blockAndForbidType =='forbid'?'禁言':blockAndForbidType =='fakeForbid'?'伪禁言':''"
                               :visible.sync="blockAndForbidDialog" width="50%" lock-scroll center>
                        <el-form label-suffix=":" label-width="100px">
                            <el-form-item style="color:orangered">
                                <span>先选择时长,会生成默认文案</span>
                            </el-form-item>
                            <el-form-item label="时长">
                                <el-select v-model="blockAndForbidForm.time" filterable clearable default-first-option @change="handleTimeChange">
                                    <el-option v-for="item in blockAndForbidTimeOptions" :key="item.value" :label="item.label" :value="item.value">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="提示" v-if="blockAndForbidType !=='fakeForbid'">
                                <el-input v-model="blockAndForbidForm.prompt" placeholder='' ></el-input>
                            </el-form-item>
                            <el-form-item label="内部操作原因">
                                <el-autocomplete
                                    class="inline-input"
                                    type="textarea"
                                    :maxlength="300"
                                    show-word-limit
                                    :autosize="{ minRows: 2}"
                                    v-model="blockAndForbidForm.reason"
                                    :fetch-suggestions="querySearchrRasonTemplate"
                                    placeholder="请输入内容"
                                    @select="handleSelectBlockAndForbid"
                                >
                                    <template slot-scope="{ item }">
                                        <span class="addr">{{item.reason}}</span>
                                    </template>
                                </el-autocomplete>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="blockAndForbidDialog = false">取消</el-button>
                            <el-button type="primary" @click="blockAndForbid">确认</el-button>
                        </div>
                    </el-dialog>

                    <el-dialog title="改名" :visible.sync="renameDialog" width="50%" lock-scroll center>
                        <el-form label-suffix=":" label-width="100px">
                            <el-form-item label="新名字">
                                <el-input v-model="renameForm.newName" placeholder=''></el-input>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="renameDialog = false">取消</el-button>
                            <el-button type="primary" @click="playerRename">确认</el-button>
                        </div>
                    </el-dialog>

                    <el-dialog title='清除部落昵称' :visible.sync="clearTribeNameShow" width="50%"
                               lock-scroll center>
                        <span>确认清除部落昵称吗？</span>

<!--                        <el-form label-suffix=":" label-width="100px">
                            <el-form-item label="言论标签">
                                <div class="opinion-tag">
                                    <el-autocomplete
                                        class="inline-input"
                                        type="textarea"
                                        :maxlength="20"
                                        show-word-limit
                                        :autosize="{ minRows: 2}"
                                        v-model="clearTribeNameForm.chatLabelLv1"
                                        :fetch-suggestions="querySearchOpinionTagLv1"
                                        placeholder="请输入一级标签"
                                        @select="handleSelectOpinionTagLv1Rename2"
                                    >
                                        <template slot-scope="{ item }">
                                            <span class="addr">{{item.reason}}</span>
                                        </template>
                                    </el-autocomplete>

                                    <el-autocomplete
                                        class="inline-input"
                                        type="textarea"
                                        :maxlength="20"
                                        show-word-limit
                                        :autosize="{ minRows: 2}"
                                        v-model="clearTribeNameForm.chatLabelLv2"
                                        :fetch-suggestions="querySearchOpinionTagLv2"
                                        placeholder="请输入二级标签"
                                        @select="handleSelectOpinionTagLv2Rename2"
                                    >
                                        <template slot-scope="{ item }">
                                            <span class="addr">{{item.reason}}</span>
                                        </template>
                                    </el-autocomplete>
                                </div>
                            </el-form-item>
                        </el-form>-->
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="clearTribeNameShow = false">取消</el-button>
                            <el-button type="primary" @click="rewriteTribeName">确认</el-button>
                        </div>
                    </el-dialog>

                    <el-dialog title='清除部落公告' :visible.sync="clearTribeBulletinShow" width="50%"
                               lock-scroll center>
                        <span>确认清除部落公告吗？</span>
<!--                        <el-form label-suffix=":" label-width="100px">
                            <el-form-item label="言论标签">
                                <div class="opinion-tag">
                                    <el-autocomplete
                                        class="inline-input"
                                        type="textarea"
                                        :maxlength="20"
                                        show-word-limit
                                        :autosize="{ minRows: 2}"
                                        v-model="clearTribeBulletinForm.chatLabelLv1"
                                        :fetch-suggestions="querySearchOpinionTagLv1"
                                        placeholder="请输入一级标签"
                                        @select="handleSelectOpinionTagLv1Bulletin"
                                    >
                                        <template slot-scope="{ item }">
                                            <span class="addr">{{item.reason}}</span>
                                        </template>
                                    </el-autocomplete>

                                    <el-autocomplete
                                        class="inline-input"
                                        type="textarea"
                                        :maxlength="20"
                                        show-word-limit
                                        :autosize="{ minRows: 2}"
                                        v-model="clearTribeBulletinForm.chatLabelLv2"
                                        :fetch-suggestions="querySearchOpinionTagLv2"
                                        placeholder="请输入二级标签"
                                        @select="handleSelectOpinionTagLv2Bulletin"
                                    >
                                        <template slot-scope="{ item }">
                                            <span class="addr">{{item.reason}}</span>
                                        </template>
                                    </el-autocomplete>
                                </div>
                            </el-form-item>
                        </el-form>-->
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="clearTribeBulletinShow = false">取消</el-button>
                            <el-button type="primary" @click="rewriteTribeBulletin">确认</el-button>
                        </div>
                    </el-dialog>
            </el-tab-pane>

            <el-tab-pane name="second" label="历史记录">
                <div class="query-panel">
                    <el-form :inline="true">
                        <el-form-item label="筛选条件:">
                            <el-select v-model="showHistoryForm.conditionType" placeholder="请选择">
                                <el-option
                                    v-for="item in filterOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="举报人id:" v-if="showHistoryForm.conditionType == 'reportId'">
                            <el-input v-model="showHistoryForm.reportId" placeholder=''></el-input>
                        </el-form-item>
                        <el-form-item label="被举报id:" v-if="showHistoryForm.conditionType == 'userId'">
                            <el-input v-model="showHistoryForm.userId" placeholder=''></el-input>
                        </el-form-item>
                        <el-form-item label="举报类型:" v-if="showHistoryForm.conditionType == 'reportType'">
                            <el-select v-model="showHistoryForm.reportType" placeholder="请选择">
                                <el-option
                                    v-for="item in reportType"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="时间范围:" v-if="showHistoryForm.conditionType == 'reportType' && showHistoryForm.reportType == 1">
                            <el-date-picker v-model="showHistoryForm.speakTimeStart" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'00:00:00'">
                            </el-date-picker>
                            至
                            <el-date-picker v-model="showHistoryForm.speakTimeEnd" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'00:00:00'">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="showHistory">查询</el-button>
                        </el-form-item>
                    </el-form>

                    <el-table :data="reportHistoryData" border>
                        <el-table-column prop="accountSid" label="被举报人sid"></el-table-column>
                        <el-table-column prop="userId" label="被举报角色长id"></el-table-column>
                        <el-table-column prop="nick" label="被举报人昵称"></el-table-column>
                        <el-table-column prop="level" label="被举报人等级"></el-table-column>
                        <el-table-column prop="charge" label="被举报人总充值（分）"></el-table-column>
                        <el-table-column prop="reportType" label="举报类型">
                            <template slot-scope="scope">
                                <span v-for="item in reportType" v-if="scope.row.reportType == item.value">{{item.label}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="speakTime" label="发送时间"></el-table-column>
                        <el-table-column prop="reportId" label="举报人id"></el-table-column>
                        <el-table-column prop="reportNick" label="举报人昵称"></el-table-column>
                        <el-table-column prop="reportContent" label="举报内容"></el-table-column>
                        <el-table-column prop="" label="处理情况"></el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
</template>

<script>
    import gameApi from '../../service/game_api'
    import configSettingApi from '../../service/config_setting_api'
    import {
        mapState
    } from 'vuex';
    import paginationController from '../../mixins/pagination'
    import actionConfirm from '../../mixins/action_confirm'
    import Utils from '../../lib/utils'

    export default {
        name: "query_report",
        data () {
            return {
                Utils: Utils,
                activeName: 'first',
                reportType: [
                    {
                        value: 1,
                        label: '违规言论（辱骂）'
                    },
                    {
                        value: 2,
                        label: '违规昵称'
                    },
                    {
                        value: 3,
                        label: '玩家作弊'
                    },
                    {
                        value: 4,
                        label: '其他'
                    },
                    {
                        value: 5,
                        label: '广告消息'
                    },
                    {
                        value: 6,
                        label: '违法消息'
                    },
                    {
                        value: 7,
                        label: '恶意骚扰'
                    },
                    {
                        value: 201,
                        label: '部落名违规'
                    },
                    {
                        value: 202,
                        label: '部落公告违规'
                    }
                ],
                blockAndForbidType: '',
                blockAndForbidDialog: false,
                blockAndForbidForm: {
                    reason: '-',
                    prompt: '',
                    time: '',
                    chatLabelLv1: '-',
                    chatLabelLv2: '-'
                },
                blockAndForbidTimeOptions: [
                    {
                        label: '永久',
                        value: -1
                    },
                    {
                        label: '1小时',
                        value: 60
                    },
                    {
                        label: '3小时',
                        value: 180
                    },
                    {
                        label: '12小时',
                        value: 720
                    },
                    {
                        label: '1天',
                        value: 1440
                    },
                    {
                        label: '3天',
                        value: 4320
                    },
                    {
                        label: '7天',
                        value: 10080
                    },
                    {
                        label: '14日',
                        value: 20160
                    },
                    {
                        label: '30日',
                        value: 43200
                    },
                ],
                reasonTemplateData: [],
                playerData: [],
                renameDialog: false,
                renameForm: {
                    newName: '',
                    reason: '-',
                    chatLabelLv1: '-',
                    chatLabelLv2: '-',
                },
                // 言论标签数据
                opinionTagData: [],
                opinionTagDataLv1: [],
                opinionTagDataLv2: [],

                clearTribeNameShow: false,
                clearTribeNameForm: {},

                clearTribeBulletinShow: false,
                clearTribeBulletinForm: {},

                filterOptions: [
                    {
                        value: 'reportId',
                        label: '举报人id'
                    },
                    {
                        value: 'userId',
                        label: '被举报人id'
                    },
                    {
                        value: 'reportType',
                        label: '举报类型'
                    },
                ],
                showHistoryForm: {
                    conditionType: '',
                    reportId: '',
                    userId: '',
                    reportType: '',
                    speakTimeStart: '',
                    speakTimeEnd: ''
                },
                reportHistoryData: []
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
            }),
        },
        mixins: [paginationController, actionConfirm],
        mounted() {
            this.showAllReports();
            this.getReasonListAll();
            this.getOpinionTagListAll();
        },
        methods: {
            tabClickChange(tab) {

            },
            // 模板列表查询
            getReasonListAll() {
                configSettingApi.reasonList({
                    token: this.token
                }).then(res => {
                    this.reasonTemplateData = res;
                })
            },

            querySearchrRasonTemplate(queryString, cb) {
                var data = this.reasonTemplateData;
                var results = queryString ? data.filter(this.createFilter(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilter(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectBlockAndForbid(item) {
                this.blockAndForbidForm.reason = item.reason;
            },
            handleSelectRename(item) {
                this.renameForm.reason = item.reason;
            },
            showAllReports() {
                gameApi.showAllReports({
                    token: this.token
                }).then(res => {
                    this.dataHandled = res;
                })
            },

            handleTimeChange(time) {
                if (time == '-1') {
                    if (this.blockAndForbidType == 'block') {
                        this.blockAndForbidForm.prompt = '您的账号当前已被永久封停。'
                        this.blockAndForbidForm.reason = '封停原因:'
                    } else if (this.blockAndForbidType == 'forbid') {
                        this.blockAndForbidForm.prompt = '您的角色当前已被永久禁言，请注意言行，文明交流，共同维护良好的游戏环境。'
                        this.blockAndForbidForm.reason = '禁言原因:'
                    } else if (this.blockAndForbidType == 'fakeForbid') {
                        this.blockAndForbidForm.prompt = '您的角色当前已被永久伪禁言。'
                        this.blockAndForbidForm.reason = '伪禁言原因:'
                    }
                } else {
                    if (this.blockAndForbidType == 'block') {
                        this.blockAndForbidForm.prompt = '您的账号当前已被封停。'
                        this.blockAndForbidForm.reason = '封停原因:'
                    } else if (this.blockAndForbidType == 'forbid') {
                        this.blockAndForbidForm.prompt = '您因违规发言已被禁言，请注意言行，文明交流，共同维护良好的游戏环境。'
                        this.blockAndForbidForm.reason = '禁言原因:'
                    } else if (this.blockAndForbidType == 'fakeForbid') {
                        this.blockAndForbidForm.prompt = '-'
                        this.blockAndForbidForm.reason = '伪禁言原因:'
                    }
                }
            },

            blockAndForbidShow(type,data) {
                this.blockAndForbidType = type;
                this.serverGameList.forEach(gameItem => {
                    if (gameItem.server_number == data.gameServer) {
                        data.uri = gameItem.inner_urls.split(';')[0];
                    }
                    if (gameItem.children) {
                        for (let child of gameItem.children) {
                            if (child.server_number == data.gameServer){
                                data.uri = child.inner_urls.split(';')[0];
                            }
                        }
                    }
                })

                this.playerData = data;
                this.blockAndForbidDialog = true;
                this.blockAndForbidForm = {
                    prompt : '',
                    time: '',
                    reason: '',
                    chatLabelLv1: '-',
                    chatLabelLv2: '-'
                };
            },

            // 封号/禁言/伪禁言
            blockAndForbid() {
                var self = this;
                var data = this.blockAndForbidForm;
                var playData = this.playerData;

                if (data.prompt == '' || data.time == '' || data.reason == '') {
                    self.$message({
                        type: 'warning',
                        message: '请填写完所有选项!'
                    })
                    return;
                }

                var blockPrompt = '';
                var blockPromptConfirm = '';
                var forbidPrompt = '';
                var forbidPromptConfirm = '';
                var fakeForbidPrompt = '';
                var fakeForbidPromptConfirm = '';
                if (data.time !== -1) {
                    var finalDate = Utils.formatDate(new Date().getTime() + parseInt(data.time*60000));
                    // blockPrompt = data.prompt + " 解封时间为(" + finalDate + ')';
                    blockPromptConfirm = data.prompt + " 解封时间为(" + finalDate + ')';
                    blockPrompt = data.prompt;
                    // forbidPrompt = data.prompt + " 解禁时间为(" + finalDate + ')';
                    forbidPromptConfirm = data.prompt + " 解禁时间为(" + finalDate + ')';
                    forbidPrompt = data.prompt;
                    // fakeForbidPrompt = data.prompt + " 解禁时间为(" + finalDate + ')';
                    fakeForbidPromptConfirm = data.prompt + " 解禁时间为(" + finalDate + ')';
                    fakeForbidPrompt = data.prompt;
                } else {
                    blockPrompt = data.prompt;
                    forbidPrompt = data.prompt;
                    fakeForbidPrompt = data.prompt;
                }


                if (self.blockAndForbidType == 'block') {
                    this.$confirm(blockPromptConfirm, '最终提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        gameApi.blockRole({
                            token: self.token,
                            blockRoleBO: {
                                prompt : blockPrompt,
                                time: data.time,
                                reason: data.reason,
                                chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                                gameUri: playData.uri,
                                gameServer: playData.gameServer,
                                userId: playData.userId,
                                handleTag:"report",
                                handleId: playData.id
                            }
                        }).then(res => {
                            self.blockAndForbidDialog = false;
                            self.$message({
                                type: 'success',
                                message: '封停角色成功!'
                            })
                            self.showAllReports();
                        })
                    }).catch(action => {

                    });
                } else if (self.blockAndForbidType == 'forbid') {
                    if (data.time !== -1) {
                        this.$confirm(forbidPromptConfirm, '最终提示', {
                            distinguishCancelAndClose: true,
                            confirmButtonText: '确定',
                            cancelButtonText: '取消'
                        }).then(() => {
                            gameApi.forbidSpeak({
                                token: self.token,
                                forbidSpeakBO: {
                                    prompt : forbidPrompt,
                                    time: data.time,
                                    reason: data.reason,
                                    chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                                    gameUri: playData.uri,
                                    gameServer: playData.gameServer,
                                    userId: playData.userId,
                                    handleTag:"report",
                                    handleId: playData.id
                                }
                            }).then(res => {
                                self.blockAndForbidDialog = false;
                                self.$message({
                                    type: 'success',
                                    message: '禁言成功!'
                                })
                                self.showAllReports();
                            })
                        }).catch(action => {

                        });
                    } else {
                        gameApi.forbidSpeak({
                            token: self.token,
                            forbidSpeakBO: {
                                prompt : forbidPrompt,
                                time: data.time,
                                reason: data.reason,
                                chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                                gameUri: playData.uri,
                                gameServer: playData.gameServer,
                                userId: playData.userId,
                                handleTag:"report",
                                handleId: playData.id
                            }
                        }).then(res => {
                            self.blockAndForbidDialog = false;
                            self.$message({
                                type: 'success',
                                message: '禁言成功!'
                            })
                            self.showAllReports();
                        })
                    }

                } else if (self.blockAndForbidType == 'fakeForbid') {
                    this.$confirm(fakeForbidPromptConfirm, '最终提示', {
                        distinguishCancelAndClose: true,
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        gameApi.fakeForbidSpeak({
                            token: self.token,
                            fakeForbidSpeakBO: {
                                prompt : fakeForbidPrompt,
                                time: data.time,
                                reason: data.reason,
                                chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                                gameUri: playData.uri,
                                gameServer: playData.gameServer,
                                userId: playData.userId,
                                handleTag:"report",
                                handleId: playData.id
                            }
                        }).then(res => {
                            self.blockAndForbidDialog = false;
                            self.$message({
                                type: 'success',
                                message: '伪禁言成功!'
                            })
                            self.showAllReports();
                        })
                    }).catch(action => {

                    });
                }
            },
            renameShow(data) {
                this.serverGameList.forEach(gameItem => {
                    if (gameItem.server_number == data.gameServer) {
                        data.uri = gameItem.inner_urls.split(';')[0];
                    }
                    if (gameItem.children) {
                        for (let child of gameItem.children) {
                            if (child.server_number == data.gameServer){
                                data.uri = child.inner_urls.split(';')[0];
                            }
                        }
                    }
                })
                this.playerData = data;
                this.renameDialog = true;
                var newName = '探索者' + data.userId.toString().slice(-6);
                this.renameForm = {
                    newName: newName,
                    reason: '-',
                    chatLabelLv1: '-',
                    chatLabelLv2: '-',
                };
            },
            // 模板列表查询
            getOpinionTagListAll() {
                configSettingApi.opinionTagList({
                    token: this.token
                }).then(res => {
                    this.opinionTagData = res;
                    this.opinionTagData.forEach(item => {
                        if (item.level == 1) {
                            this.opinionTagDataLv1.push(item);
                        } else if (item.level == 2) {
                            this.opinionTagDataLv2.push(item);
                        }
                    })
                })
            },

            querySearchOpinionTagLv1(queryString, cb) {
                var data = this.opinionTagDataLv1;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            querySearchOpinionTagLv2(queryString, cb) {
                var data = this.opinionTagDataLv2;
                var results = queryString ? data.filter(this.createFilterOpinionTag(queryString)) : data;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },

            createFilterOpinionTag(queryString) {
                return (data) => {
                    return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelectOpinionTagLv1Rename(item) {
                this.renameForm.chatLabelLv1 = item.reason;
            },
            handleSelectOpinionTagLv2Rename(item) {
                this.renameForm.chatLabelLv2 = item.reason;
            },

            // 改名
            playerRename() {
                var self = this;
                var data = this.renameForm;
                var playData = this.playerData;

                if (data.newName == '' || data.reason == '') {
                    self.$message({
                        type: 'warning',
                        message: '请填写完所有选项!'
                    })
                    return;
                }

                gameApi.playerRename({
                    token: self.token,
                    renameBO: {
                        newName: data.newName,
                        reason: data.reason,
                        chatLabel: data.chatLabelLv1 + '-' + data.chatLabelLv2,
                        gameUri: playData.uri,
                        gameServer: playData.gameServer,
                        userId: playData.userId,
                        handleTag:"report",
                        handleId: playData.id
                    }
                }).then(res => {
                    self.renameDialog = false;
                    self.$message({
                        type: 'success',
                        message: '改名成功!'
                    })
                    self.showAllReports();
                })
            },

            handleReports(data) {
                var self = this;
                self.$confirm('确定放弃处理吗？', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    gameApi.handleReports({
                        token: self.token,
                        id: data.id
                    }).then(res => {
                        self.$message({
                            type: 'success',
                            message: '操作成功!',
                        })
                        self.showAllReports();
                    })
                })
            },

            handleSelectOpinionTagLv1Rename2(item) {
                this.clearTribeNameForm.chatLabelLv1 = item.reason;
            },
            handleSelectOpinionTagLv2Rename2(item) {
                this.clearTribeNameForm.chatLabelLv2 = item.reason;
            },

            handleSelectOpinionTagLv1Bulletin(item) {
                this.clearTribeBulletinForm.chatLabelLv1 = item.reason;
            },
            handleSelectOpinionTagLv2Bulletin(item) {
                this.clearTribeBulletinForm.chatLabelLv2 = item.reason;
            },

            // 清除部落昵称展示
            showClearTribeName(data) {
                this.serverGameList.forEach(gameItem => {
                    if (gameItem.server_number == data.gameServer) {
                        data.uri = gameItem.inner_urls.split(';')[0];
                    }
                    if (gameItem.children) {
                        for (let child of gameItem.children) {
                            if (child.server_number == data.gameServer){
                                data.uri = child.inner_urls.split(';')[0];
                            }
                        }
                    }
                })

                this.clearTribeNameShow = true;
                this.clearTribeNameForm.tribeId = JSON.parse(data.extend).tribeId;
                this.clearTribeNameForm.uri = data.uri;
                this.clearTribeNameForm.zoneId = data.gameServer;
                this.clearTribeNameForm.id = data.id;
            },

            // 清除部落公告展示
            showClearTribeBulletin(data) {
                this.serverGameList.forEach(gameItem => {
                    if (gameItem.server_number == data.gameServer) {
                        data.uri = gameItem.inner_urls.split(';')[0];
                    }
                    if (gameItem.children) {
                        for (let child of gameItem.children) {
                            if (child.server_number == data.gameServer){
                                data.uri = child.inner_urls.split(';')[0];
                            }
                        }
                    }
                })

                this.clearTribeBulletinShow = true;
                this.clearTribeBulletinForm.tribeId = JSON.parse(data.extend).tribeId;
                this.clearTribeBulletinForm.uri = data.uri;
                this.clearTribeBulletinForm.zoneId = data.gameServer;
                this.clearTribeBulletinForm.id = data.id;
            },

            // 清除部落昵称
            rewriteTribeName() {
                var data = this.clearTribeNameForm;

                gameApi.rewriteTribeName({
                    token: this.token,
                    clearTribeBO: {
                        uri: data.uri,
                        zoneId: data.zoneId,
                        tribeId: data.tribeId,
                        reason: '-',
                        handleTag:"report",
                        handleId: data.id
                    }
                }).then(res => {
                    this.clearTribeNameShow = false;
                    data.chatLabelLv1 ='';
                    data.chatLabelLv2 ='';
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    })
                    this.showAllReports();
                })
            },

            // 清除部落公告
            rewriteTribeBulletin() {
                var data = this.clearTribeBulletinForm;
                gameApi.rewriteTribeBulletin({
                    token: this.token,
                    clearTribeBO: {
                        uri: data.uri,
                        zoneId: data.zoneId,
                        tribeId: data.tribeId,
                        reason: '-' ,
                        handleTag:"report",
                        handleId: data.id
                    }
                }).then(res => {
                    this.clearTribeBulletinShow = false;
                    data.chatLabelLv1 ='';
                    data.chatLabelLv2 ='';
                    this.$message({
                        type: 'success',
                        message: '操作成功!'
                    })
                    this.showAllReports();
                })
            },

            // 举报历史记录
            showHistory() {
                gameApi.showHistory({
                    token: this.token,
                    showHistoryForm: this.showHistoryForm
                }).then(res => {
                    this.reportHistoryData = res;
                })
            },

            // 跳转聊天记录查询
            toChat(id) {
                this.$router.push({
                    path: '/players/query_chat',
                    query: {
                        userId: id,
                        chatChannel: '100'
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .player-btn {
        margin-bottom: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/views/players/query_report.vue